import React from 'react';
import {useSelector} from 'react-redux';
import {useSubcontractorsStore} from './SubcontractorsStore';
import SubcontractorsView from './SubcontractorsView';
import documentKpiService from '../../services/documentKpi/DocumentKpiService';

function SubcontractorsContainer() {
  const organisation = useSelector(state => state.organisation);
  const {state: {subcontractors}, dispatch} = useSubcontractorsStore();

  React.useEffect(() => {
    dispatch({type: 'FETCH_DATA'});
  }, []);

  function handleGetInvalidDocuments(page, pageSize) {
    return documentKpiService.getInvalidSubcontractorsDocumentsByOrganisation(
      organisation.organisationId,
      subcontractors.dossierCountry,
      page,
      pageSize
    );
  }

  return (
    <SubcontractorsView onGetDocuments={handleGetInvalidDocuments}/>
  );
}

export default SubcontractorsContainer;
